import Vue from 'vue';
import moment from 'moment';
import VeeValidate from 'vee-validate';
import VueWait from 'vue-wait';
import vuetify from './plugins/vuetify';
import './plugins/api';
import './plugins/bus';
import './plugins/confirm-cancel';
import './plugins/toast';
import './plugins/uuid';
import './plugins/date-filter';
import './plugins/text-filter';
import './plugins/auth.service';
import './plugins/graph.service';
import './plugins/unit-search.service';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
Vue.use(VeeValidate);
Vue.use(VueWait);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
